import { searchRegistry } from "../../platform/search/register/search-registry";
import { Files } from "lucide-react";


searchRegistry.register([
    {
        id: "policy.management",
        title: "Manage Policies",
        description: "View Policies ",
        route: "/policy",
        category: "Administration",
        permissions: ["ADMIN"],
        tags: ["edit policy", "policy"],
        icon: Files,
        type: 'result'
    },
    {
        id: "policy",
        title: "View Policies",
        description: "View Policies",
        route: "/policy",
        category: "Administration",
        permissions: ["EMPLOYEE"],
        tags: ["policy"],
        icon: Files,
        type: 'result'
    },
])
